import { AlertCircle, AlertTriangle, CheckCircle2, Info } from 'lucide-react';

export type Tone = 'info' | 'success' | 'warning' | 'danger';

export const TONE_STYLE: Record<Tone, string> = {
  info: 'border-info-border bg-info-soft text-info-ink',
  success: 'border-success-border bg-success-soft text-success-ink',
  warning: 'border-warning-border bg-warning-soft text-warning-ink',
  danger: 'border-danger-border bg-danger-soft text-danger-ink',
};

export const TONE_ICON: Record<Tone, typeof Info> = {
  info: Info,
  success: CheckCircle2,
  warning: AlertTriangle,
  danger: AlertCircle,
};

/** Spoken prefix so the tone is not conveyed by colour/icon alone (WCAG 1.4.1, 1.3.1). */
export const TONE_LABEL: Record<Tone, string> = {
  info: 'Information',
  success: 'Success',
  warning: 'Warning',
  danger: 'Error',
};
